import { render, staticRenderFns } from "./BoardToFigmaModal.vue?vue&type=template&id=1252e49a&scoped=true"
import script from "./BoardToFigmaModal.vue?vue&type=script&lang=js"
export * from "./BoardToFigmaModal.vue?vue&type=script&lang=js"
import style0 from "./BoardToFigmaModal.vue?vue&type=style&index=0&id=1252e49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252e49a",
  null
  
)

export default component.exports